/* eslint-disable */
import { SVGProps } from "react";

const SvgMounting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59.8}
    height={43.782}
    fill="currentColor"
    viewBox="0 0 59.8 43.782"
    {...props}
  >
    <g data-name="solar-energy (1)">
      <g data-name="Group 491">
        <g data-name="Group 490">
          <path
            data-name="Path 588"
            d="M15.196 11.746h2.477l2.851-3.2h-2.488Z"
          />
          <path data-name="Path 589" d="M9.856 11.746h2.477l2.851-3.2h-2.488Z" />
          <path
            data-name="Path 590"
            d="M29.654 4.271h-2.478l-1.9 2.136h2.488Z"
          />
          <path
            data-name="Path 591"
            d="M18.976 4.271h-2.477l-1.9 2.136h2.488Z"
          />
          <path
            data-name="Path 592"
            d="M20.535 11.746h2.477l2.851-3.2h-2.488Z"
          />
          <path
            data-name="Path 593"
            d="M24.315 4.271h-2.477l-1.9 2.136h2.491Z"
          />
          <path
            data-name="Path 594"
            d="M.003 42.715a1.071 1.071 0 0 0 1.068 1.068h28.832v-25.63H.003Z"
          />
          <path
            data-name="Path 595"
            d="M48.053 28.832h-4.271a1.071 1.071 0 0 0-1.068 1.068v13.882h6.407V29.9a1.071 1.071 0 0 0-1.068-1.068Z"
          />
          <path
            data-name="Path 596"
            d="M32.035 17.47v26.312h8.543V29.9a3.213 3.213 0 0 1 3.2-3.2h4.271a3.213 3.213 0 0 1 3.2 3.2v13.882h7.475a1.071 1.071 0 0 0 1.068-1.068V17.47L45.917.608Z"
          />
          <path
            data-name="Path 597"
            d="M25.874 11.746h2.477l2.851-3.2h-2.488Z"
          />
          <path
            data-name="Path 598"
            d="M30.615 6.407h2.488l1.89-2.136h-2.477Z"
          />
          <path
            data-name="Path 599"
            d="M14.886 0a1.06 1.06 0 0 0-.822.384L1.196 16.018h29.27L43.654 0Zm14.747 13.519a1.047 1.047 0 0 1-.8.363H7.475a1.069 1.069 0 0 1-.8-1.773l4.784-5.382a.011.011 0 0 1 0-.008.01.01 0 0 1 .008 0l3.748-4.218a1.047 1.047 0 0 1 .8-.363h21.36a1.068 1.068 0 0 1 .8 1.773Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgMounting;
